import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/don-tu/don-tu'

// Lọc danh sách đơn từ
export function locDanhSachDonTu(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-don-tu`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy thông tin đơn từ
export function layChiTietDonTu(requestId: number) {
  try {
    return axiosApi.get(`${BASE}/${requestId}/lay-chi-tiet-don-tu`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo đơn từ mới
export function taoDonTu(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-don-tu`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật đơn từ
export function capNhatDonTu(requestId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${requestId}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Hủy đơn từ
export function huyDonTu(requestId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/${requestId}/huy`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách đơn từ của user
export function layDanhSachDonTuNhanVien(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/danh-sach-don-tu`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách đơn từ chờ xử lý của người duyệt
export function layDonTuChoXuLy(approverId: number) {
  try {
    return axiosApi.get(`${BASE}/nguoi-duyet/${approverId}/don-tu-cho-xu-ly`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
